import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface PortfolioExportState {
  newRun: {
    totalInSupabase: number;
    totalInBatch: {
      [k in string]: number;
    };
  };
  assetLevelDownload: {
    [k in string]: number;
  };
  summaryStatusModal: {
    isOpen: boolean;
    highlightedSummaryId: string | null;
  };
  rerunningPortfolioIds: string[];
  /**
   * Analysis the user confirmed a re-process for on the collection page; the
   * analysis list row claims it on mount and runs it. Kept out of the URL so a
   * link can't mutate data on paste or refresh.
   */
  pendingRerunPortfolioId: string | null;
}

const initialState: PortfolioExportState = {
  newRun: {
    totalInSupabase: 0,
    totalInBatch: {},
  },
  assetLevelDownload: {},
  summaryStatusModal: {
    isOpen: false,
    highlightedSummaryId: null,
  },
  rerunningPortfolioIds: [],
  pendingRerunPortfolioId: null,
};

export const portfolioExportSlice = createSlice({
  name: "portfolioExport",
  initialState,
  reducers: {
    incrementNewRunTotalInSupabaseBy: (state, action: PayloadAction<number>) => {
      state.newRun.totalInSupabase = state.newRun.totalInSupabase + action.payload;
    },
    setNewRunTotalInSupabaseTo: (state, action: PayloadAction<number>) => {
      state.newRun.totalInSupabase = action.payload;
    },
    setNewRunTotalInBatchTo: (state, action: PayloadAction<{ id: string; count: number }>) => {
      state.newRun.totalInBatch = {
        ...state.newRun.totalInBatch,
        [action.payload.id]: action.payload.count,
      };
    },
    setSummaryStatusModal: (state, action: PayloadAction<{ isOpen: boolean; highlightedSummaryId?: string }>) => {
      state.summaryStatusModal = {
        isOpen: action.payload.isOpen,
        highlightedSummaryId: action.payload.highlightedSummaryId || null,
      };
    },
    addRerunningPortfolio: (state, action: PayloadAction<string>) => {
      if (!state.rerunningPortfolioIds.includes(action.payload)) {
        state.rerunningPortfolioIds.push(action.payload);
      }
    },
    removeRerunningPortfolio: (state, action: PayloadAction<string>) => {
      state.rerunningPortfolioIds = state.rerunningPortfolioIds.filter((id) => id !== action.payload);
    },
    setPendingRerun: (state, action: PayloadAction<string>) => {
      state.pendingRerunPortfolioId = action.payload;
    },
    clearPendingRerun: (state) => {
      state.pendingRerunPortfolioId = null;
    },
  },
});

export const portfolioExportActions = portfolioExportSlice.actions;

export default portfolioExportSlice.reducer;
